export var BlockColors;

(function (BlockColors) {
  BlockColors["BLUE"] = "blue";
  BlockColors["ORANGE"] = "orange";
  BlockColors["RED"] = "red";
  BlockColors["PURPLE"] = "purple";
  BlockColors["GREEN"] = "green";
  BlockColors["GRAY"] = "gray";
})(BlockColors || (BlockColors = {}));